var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForwardArrow = function SvgForwardArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 10,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.35a.65.65 0 1 0 0 1.3zm11.46 1.11a.65.65 0 0 0 0-.92L8.323.404a.65.65 0 1 0-.92.919L11.082 5 7.404 8.677a.65.65 0 1 0 .919.92zM1 5.65h11v-1.3H1z"
  })));
};
export { SvgForwardArrow as ReactComponent };